module.exports = __webpack_public_path__ + "img/2.3ce5008b.png";